import React, { lazy } from 'react';
import { CheckIcon } from 'lucide-react';
const img1Base = 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/WhatsApp_Image_2026-02-14_at_20.04.22_1.webp?v=1771096156';
const img2Base = 'https://cdn.shopify.com/s/files/1/0963/9372/4268/files/WhatsApp_Image_2026-02-14_at_19.27.01_1.webp?v=1771095969';
const learningItems = [{
  title: 'Te guiaremos desde cero hasta nivel profesional para que domines la elaboración de jabones artesanales como:',
  items: ['Jabones aromáticos', 'Jabones para eventos y celebraciones', 'Jabones navideños', 'Jabones tipo cupcake', 'Jabones con diseños especiales', 'Jabones con efecto mármol y muchos más...']
}, {
  title: 'Sabrás las medidas y proporciones exactas de cada ingrediente para que tus jabones siempre queden con la dureza, textura y acabado perfecto.',
  items: []
}];
const specializedSoaps = {
  title: 'Dominarás la elaboración de jabones especializados para el cuidado de la piel como:',
  items: ['Jabones para piel grasa', 'Jabones para piel sensible', 'Jabones para piel seca', 'Jabones para piel mixta y muchos más...']
};
const additionalPoints = ['Descubrirás la técnica que usan las marcas premium para producir jabones artesanales de alta calidad reduciendo hasta un 60% el costo en materiales.', 'Aprenderás a convertir tu conocimiento en un negocio real: desde elegir los mejores ingredientes hasta presentar y vender tus productos como una profesional.', 'Tendrás acceso a proveedores verificados en tu país para conseguir materiales al mejor precio.', 'Saldrás con todo lo que necesitas para posicionarte en el mercado de los jabones artesanales y generar ingresos extras con tus propias creaciones.'];
export function LearningContent() {
  return <section className="w-full bg-[var(--bg-darker)] py-8 md:py-12 px-4" id="learning-content-section" data-id="element-181">
      <div className="max-w-5xl mx-auto" data-id="element-182">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-black text-[var(--text-light)] mb-6 md:mb-8 text-center reveal" data-id="element-183">
          ¿QUÉ VAS A APRENDER?
        </h2>

        <div className="mb-6 md:mb-8 reveal" data-delay="1" data-id="element-184">
          <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-185">
            <CheckIcon className="w-6 h-6 md:w-8 md:h-8 text-[var(--accent-orange)] flex-shrink-0 mt-1" data-id="element-186" />
            <p className="text-base md:text-lg lg:text-xl text-[var(--text-light)] leading-relaxed" data-id="element-187">
              {learningItems[0].title}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 ml-8 md:ml-12 mb-4 md:mb-6" data-id="element-188">
            {learningItems[0].items.map((item, index) => <div key={index} className="flex items-center gap-2 reveal-left" data-delay={index + 2} data-id="element-189">
                <span className="text-2xl" data-id="element-190">✨</span>
                <p className="text-sm md:text-base lg:text-lg text-[var(--text-gray)]" data-id="element-191">
                  {item}
                </p>
              </div>)}
          </div>
        </div>

        <div className="flex items-start gap-3 md:gap-4 mb-6 md:mb-8 reveal" data-delay="2" data-id="element-192">
          <CheckIcon className="w-6 h-6 md:w-8 md:h-8 text-[var(--accent-orange)] flex-shrink-0 mt-1" data-id="element-193" />
          <p className="text-base md:text-lg lg:text-xl text-[var(--text-light)] leading-relaxed" data-id="element-194">
            {learningItems[1].title}
          </p>
        </div>

        <div className="rounded-xl overflow-hidden mb-6 md:mb-8 shadow-2xl reveal" data-delay="3" data-id="element-195">
          <img src={`${img1Base}&width=700`} srcSet={`${img1Base}&width=400 400w, ${img1Base}&width=700 700w, ${img1Base}&width=1024 1024w`} sizes="(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 665px" alt="Variedad de jabones artesanales con diferentes diseños y aromas" className="w-full h-auto object-cover" loading="lazy" decoding="async" width={1024} height={768} data-id="element-196" />
        </div>

        <div className="mb-6 md:mb-8 reveal" data-delay="1" data-id="element-197">
          <div className="flex items-start gap-3 md:gap-4 mb-3 md:mb-4" data-id="element-198">
            <CheckIcon className="w-6 h-6 md:w-8 md:h-8 text-[var(--accent-orange)] flex-shrink-0 mt-1" data-id="element-199" />
            <p className="text-base md:text-lg lg:text-xl text-[var(--text-light)] leading-relaxed" data-id="element-200">
              {specializedSoaps.title}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 ml-8 md:ml-12 mb-4 md:mb-6" data-id="element-201">
            {specializedSoaps.items.map((item, index) => <div key={index} className="flex items-center gap-2 reveal-left" data-delay={index + 2} data-id="element-202">
                <span className="text-2xl" data-id="element-203">✨</span>
                <p className="text-sm md:text-base lg:text-lg text-[var(--text-gray)]" data-id="element-204">
                  {item}
                </p>
              </div>)}
          </div>
        </div>

        {additionalPoints.map((point, index) => <div key={index} className="flex items-start gap-3 md:gap-4 mb-4 md:mb-6 reveal" data-delay={index + 1} data-id="element-205">
            <CheckIcon className="w-6 h-6 md:w-8 md:h-8 text-[var(--accent-orange)] flex-shrink-0 mt-1" data-id="element-206" />
            <p className="text-base md:text-lg lg:text-xl text-[var(--text-light)] leading-relaxed" data-id="element-207">
              {point}
            </p>
          </div>)}

        <div className="rounded-xl overflow-hidden shadow-2xl mb-6 md:mb-8 reveal" data-delay="4" data-id="element-208">
          <img src={`${img2Base}&width=700`} srcSet={`${img2Base}&width=400 400w, ${img2Base}&width=700 700w, ${img2Base}&width=1024 1024w`} sizes="(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 665px" alt="Jabones artesanales especializados para diferentes tipos de piel" className="w-full h-auto object-cover" loading="lazy" decoding="async" width={1024} height={768} data-id="element-209" />
        </div>
      </div>
    </section>;
}